import { lazy } from 'react';

const LazyIntegrationImportWizard = lazy(() => import('./integration-import-wizard'));
export default LazyIntegrationImportWizard;
